import React from 'react'
import { CSSTransition } from 'react-transition-group'

const Opening = (props) => {

    const [imageLoaded, setImageLoaded]= React.useState(false);

    return (
        <CSSTransition in={true} appear={true} timeout={600} classNames="fade">
        <div className={`Opening image-${
            imageLoaded ? 'visible' :  'hidden'
          }`}  >
            <img src='foto di ui.jpeg' alt='gambar diri' className={`smooth-image image-${
            imageLoaded ? 'visible' :  'hidden'
          }`}
          onLoad={()=> setImageLoaded(true)} />
            {!imageLoaded && (
            <div className="smooth-preloader">
                <span className="loader" />
            </div>
            )}
            <h1 id='panggil'>Hello {props.nama}!</h1>
            <p> My name is Dzikri Qalam Hatorangan</p>
            <p> from Universitas Indonesia </p> 
            <p> and I'm a Computer Science Student</p> 
        </div>
        </CSSTransition>
        
    )
}

export default Opening
